import { AUFTRAG_API } from '@Constants/backendConstants';
import { useLogger, useSynqoHttp } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

interface BookContainerRentOptions {
    standing_time_ids: string[];
    billed_until: string;
}

// @ai-generated 2026-10-21T10:12:41+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function useBookContainerRent() {
    const { info } = useLogger();
    const { post } = useSynqoHttp(`${AUFTRAG_API}/container_rent:book.v1`);

    const { mutateAsync: startBatchProcess, isPending: isBookingPending } = useMutation({
        mutationFn: (options: BookContainerRentOptions) => post<undefined, BookContainerRentOptions>('', options),
    });

    const bookContainerRent = useCallback(
        (standingTimeIds: string[], billedUntil: string) => {
            info(`Started container rent booking for ${standingTimeIds.length} standing times`);
            return startBatchProcess({ standing_time_ids: standingTimeIds, billed_until: billedUntil });
        },
        [info, startBatchProcess],
    );

    return { bookContainerRent, isBookingPending };
}
